"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntriesScoutHashGroupEntryChildEntriesAttributes = void 0;
var EntriesScoutHashGroupEntryChildEntriesAttributes = (function () {
    function EntriesScoutHashGroupEntryChildEntriesAttributes() {
    }
    EntriesScoutHashGroupEntryChildEntriesAttributes.getAttributeTypeMap = function () {
        return EntriesScoutHashGroupEntryChildEntriesAttributes.attributeTypeMap;
    };
    EntriesScoutHashGroupEntryChildEntriesAttributes.discriminator = undefined;
    EntriesScoutHashGroupEntryChildEntriesAttributes.attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "lastName",
            "baseName": "last_name",
            "type": "string",
            "format": ""
        },
        {
            "name": "firstName",
            "baseName": "first_name",
            "type": "string",
            "format": ""
        },
        {
            "name": "lastNameKana",
            "baseName": "last_name_kana",
            "type": "string",
            "format": ""
        },
        {
            "name": "firstNameKana",
            "baseName": "first_name_kana",
            "type": "string",
            "format": ""
        },
        {
            "name": "birthdate",
            "baseName": "birthdate",
            "type": "string",
            "format": ""
        },
        {
            "name": "gender",
            "baseName": "gender",
            "type": "string",
            "format": ""
        },
        {
            "name": "postcode",
            "baseName": "postcode",
            "type": "string",
            "format": ""
        },
        {
            "name": "address",
            "baseName": "address",
            "type": "string",
            "format": ""
        },
        {
            "name": "googleEmail",
            "baseName": "google_email",
            "type": "string",
            "format": ""
        },
        {
            "name": "parentLastName",
            "baseName": "parent_last_name",
            "type": "string",
            "format": ""
        },
        {
            "name": "parentFirstName",
            "baseName": "parent_first_name",
            "type": "string",
            "format": ""
        },
        {
            "name": "parentRelationship",
            "baseName": "parent_relationship",
            "type": "EntriesScoutHashGroupEntryChildEntriesAttributesParentRelationshipEnum",
            "format": ""
        },
        {
            "name": "parentPhoneNumber",
            "baseName": "parent_phone_number",
            "type": "string",
            "format": ""
        }
    ];
    return EntriesScoutHashGroupEntryChildEntriesAttributes;
}());
exports.EntriesScoutHashGroupEntryChildEntriesAttributes = EntriesScoutHashGroupEntryChildEntriesAttributes;
//# sourceMappingURL=EntriesScoutHashGroupEntryChildEntriesAttributes.js.map